import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import BasicModal from '../modal/BasicModal'
import EditBanner from './EditBanner'
import { deleteBanner } from '../../store/actions/bannerAction'
import { DELETE_CONFIRM } from '../../constants/form'
import { roleListId, roleType } from '../../config/roleList'
import { checkUserRole } from '../../common/checkUserRole'

const BannerList = ({ banner }) => {
    const dispatch = useDispatch()
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)
    const [editOpen, setEditOpen] = useState(false)

    const handleDelete = useCallback(
        (id) => {
            if (window.confirm(DELETE_CONFIRM)) {
                dispatch(deleteBanner(id))
            }
        },
        [dispatch]
    )

    return (
        <>
            <BasicModal open={editOpen} setOpen={setEditOpen}>
                <EditBanner id={banner.id} setOpen={setEditOpen} />
            </BasicModal>
            <Card sx={banner?.enabled ? { width: '100%' } : { width: '45%' }}>
                <CardContent>
                    <div
                        className="home_item_box_pic_bg"
                        style={{
                            background: `url(${banner?.picLink})`,
                            backgroundPosition: 'center',
                            backgroundSize: 'cover',
                        }}
                    >
                        <div className="home_item_box_pic_text_box">
                            <div
                                className={
                                    banner?.enabled
                                        ? 'home_item_box_pic_header'
                                        : 'home_item_box_pic_header_disabled'
                                }
                            >
                                {banner.title}
                            </div>
                            <div
                                className={
                                    banner?.enabled
                                        ? 'home_item_box_pic_more'
                                        : 'home_item_box_pic_more_disabled'
                                }
                            >
                                {banner?.details}
                            </div>
                        </div>
                    </div>
                </CardContent>
                <CardActions>
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.BANNER,
                        roleType.EDIT
                    ) && (
                        <Button onClick={() => setEditOpen(true)} size="small">
                            Edit
                        </Button>
                    )}
                    {checkUserRole(
                        userInfo,
                        roleList,
                        roleListId.BANNER,
                        roleType.DELETE
                    ) &&
                        !banner?.enabled && (
                            <Button
                                color="error"
                                size="small"
                                onClick={() => handleDelete(banner.id)}
                            >
                                Delete
                            </Button>
                        )}
                </CardActions>
            </Card>
        </>
    )
}

export default BannerList
